module.exports = __webpack_public_path__ + "img/add-past-visit.297d4db9.svg";